import _app from "../../../views/_app.tsx";
import _html from "../../../views/_html.tsx";

/** IMPORTANT: This file is auto-generated by eddev. Do not edit. */
import { viewManifestReader } from "eddev/_internal";
import { dynamic } from "eddev/dynamic";
const manifest = {
  "404": dynamic(() => import("../../../views/404.tsx"), "views/404.tsx"),
  "_app": _app,
  "_html": _html,
  "archive-library": dynamic(() => import("../../../views/archive-library.tsx"), "views/archive-library.tsx"),
  "archive-news": dynamic(() => import("../../../views/archive-news.tsx"), "views/archive-news.tsx"),
  "category": dynamic(() => import("../../../views/category.tsx"), "views/category.tsx"),
  "front-page": dynamic(() => import("../../../views/front-page.tsx"), "views/front-page.tsx"),
  "page": dynamic(() => import("../../../views/page.tsx"), "views/page.tsx"),
  "search": dynamic(() => import("../../../views/search.tsx"), "views/search.tsx"),
  "single": dynamic(() => import("../../../views/single.tsx"), "views/single.tsx"),
  "single-data-embed": dynamic(() => import("../../../views/single-data-embed.tsx"), "views/single-data-embed.tsx"),
  "single-library-document": dynamic(
    () => import("../../../views/single-library-document.tsx"),
    "views/single-library-document.tsx",
  ),
  "single-rsrp-project": dynamic(
    () => import("../../../views/single-rsrp-project.tsx"),
    "views/single-rsrp-project.tsx",
  ),
  "tag": dynamic(() => import("../../../views/tag.tsx"), "views/tag.tsx"),
  "taxonomy-document-topic": dynamic(
    () => import("../../../views/taxonomy-document-topic.tsx"),
    "views/taxonomy-document-topic.tsx",
  ),
  "taxonomy-document-type": dynamic(
    () => import("../../../views/taxonomy-document-type.tsx"),
    "views/taxonomy-document-type.tsx",
  ),
  "taxonomy-publication": dynamic(
    () => import("../../../views/taxonomy-publication.tsx"),
    "views/taxonomy-publication.tsx",
  ),
  "templates/cpd-app": dynamic(() => import("../../../views/templates/cpd-app.tsx"), "views/templates/cpd-app.tsx"),
  "templates/ev-index": dynamic(() => import("../../../views/templates/ev-index.tsx"), "views/templates/ev-index.tsx"),
  "templates/home-pages": dynamic(
    () => import("../../../views/templates/home-pages.tsx"),
    "views/templates/home-pages.tsx",
  ),
  "templates/road-safety": dynamic(
    () => import("../../../views/templates/road-safety.tsx"),
    "views/templates/road-safety.tsx",
  ),
  "templates/transport-affordability": dynamic(
    () => import("../../../views/templates/transport-affordability.tsx"),
    "views/templates/transport-affordability.tsx",
  ),
};

viewManifestReader.set(manifest);

export default manifest;

if (import.meta.hot) {
  import.meta.hot.accept();
}
